<template>
  <div :class="['selectors-container', `selectors-${visibleSelectors}`]">
    <div class="selectors" v-if="show_campuses_">
      <TagSelector
        v-model="selected_campuses"
        :title="$getVisibleNames('mesh.campus', true, 'Sede')"
        :options="campuses.sort((a, b) => a.name.localeCompare(b.name))"
        :max="max_campuses"
        label_field="name"
        :disabled="disabled"
        :required="required_selectors.includes('campuses')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_careers_">
      <TagSelector
        v-model="selected_careers"
        :title="`${$getVisibleNames('mesh.career', true, 'Programa')}`"
        :options="filteredCareers"
        :max="max_careers"
        label_field="name"
        cite_field="faculty_name"
        :disabled="disabled"
        :required="required_selectors.includes('careers')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_egress_profiles_">
      <TagSelector
        v-model="selected_egress_profiles"
        :title="
          $getVisibleNames('mesh.egressprofile', false, 'Perfil De Egreso')
        "
        :options="filteredEgressProfiles"
        :max="max_egress_profiles"
        label_field="ep_custom_label"
        cite_field="career_name"
        :disabled="disabled"
        :required="required_selectors.includes('egress_profiles')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_cohorts_">
      <TagSelector
        v-model="selected_cohorts"
        :title="$t('toolbar.reports.admissionYear')"
        :options="fetched_cohorts"
        :max="max_cohorts"
        id_field="cohort"
        label_field="cohort"
        :disabled="disabled"
        :required="required_selectors.includes('cohorts')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_cohort_index_">
      <TagSelector
        v-model="selected_cohort_indices"
        :title="$t('toolbar.reports.cohortIndex')"
        :options="fetched_cohort_indices"
        :max="max_cohort_index"
        id_field="cohort_index"
        label_field="cohort_index"
        :disabled="disabled"
        :required="required_selectors.includes('cohort_index')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_levels_">
      <TagSelector
        v-model="selected_levels"
        :title="$t('toolbar.reports.level')"
        :options="filteredLevels"
        :max="max_levels"
        label_field="name"
        :disabled="disabled"
        :required="required_selectors.includes('levels')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_modalities_">
      <TagSelector
        v-model="selected_modalities"
        :title="$t('toolbar.reports.modality')"
        :options="filteredModalities"
        :max="max_modalities"
        label_field="name"
        :disabled="disabled"
        :required="required_selectors.includes('modalities')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_matters_">
      <TagSelector
        v-model="selected_matters"
        :title="
          $getVisibleNames('mesh.egressprofilematter', false, 'Asignatura')
        "
        :options="filteredMatters"
        :max="max_matters"
        label_field="matter_name"
        :disabled="disabled"
        :required="required_selectors.includes('matters')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_periods_">
      <TagSelector
        v-model="selected_periods"
        :title="$getVisibleNames('mesh.period', false, 'Período')"
        :options="filteredPeriods"
        :max="max_periods"
        :disabled="disabled"
        :required="required_selectors.includes('periods')"
        :clear_filters="clear_filters"
        :label_field="periodLabelField"
      ></TagSelector>
      <!-- label_field="name" -->
    </div>
    <div class="selectors" v-if="show_sections_">
      <TagSelector
        v-model="selected_sections"
        :title="$getVisibleNames('teaching.section', false, 'Sección')"
        :options="filteredSections"
        :max="max_sections"
        label_field="name"
        :disabled="disabled"
        :required="required_selectors.includes('sections')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_study_units_">
      <TagSelector
        v-model="selected_study_units"
        :title="$getVisibleNames('teaching.ramicro', false, 'RA Micro')"
        :options="filteredStudyUnits"
        :max="max_study_units"
        label_field="full_sentence"
        :disabled="disabled"
        :required="required_selectors.includes('study_units')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_student_status_">
      <TagSelector
        v-model="selected_student_status"
        :title="$t('toolbar.reports.progression')"
        :options="student_status"
        :max="max_student_status"
        label_field="name"
        :disabled="disabled"
        :required="required_selectors.includes('student_status')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_is_active_section_">
      <TagSelector
        v-model="selected_is_active_section"
        :title="
          $t('toolbar.reports.periodType', {
            period: $getVisibleNames('mesh.period', false, 'Período'),
          })
        "
        :options="is_active_section"
        :max="max_is_active_section"
        label_field="name"
        :disabled="disabled"
        :required="required_selectors.includes('is_active_section')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
    <div class="selectors" v-if="show_professors_">
      <TagSelectorWithPagination
        v-model="selected_professors"
        :title="$t('toolbar.reports.teachers')"
        :max="max_professors"
        label_field="full_name"
        :label_function="
          (user) => `${user.first_name || ''} ${user.last_name || ''}`.trim()
        "
        :api_endpoint="professors_api_endpoint"
        :disabled="disabled"
        :page_size="100"
        :required="required_selectors.includes('professors')"
        :clear_filters="clear_filters"
        :url_params="{ groups__id: 6 }"
      ></TagSelectorWithPagination>
    </div>
    <div
      class="selectors"
      v-if="
        show_cycles_ &&
        ((selected_egress_profiles.length > 0 && filteredCycles.length > 0) ||
          selected_egress_profiles.length == 0)
      "
    >
      <TagSelector
        v-model="selected_cycles"
        :title="$getVisibleNames('mesh.cycle', false, 'Ciclo Formativo')"
        :options="filteredCycles"
        :max="max_cycles"
        label_field="name"
        :disabled="disabled"
        :required="required_selectors.includes('cycles')"
        :clear_filters="clear_filters"
      ></TagSelector>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  components: {
    TagSelector: () => import("./TagSelector"),
    TagSelectorWithPagination: () => import("./TagSelectorWithPagination"),
  },
  props: {
    /**
     * Define los selectores que se mostraran.
     * La opcion por defecto "all" mostrará todos los selectores disponibles.
     * @values campuses careers egress_profiles levels periods matters sections professors
     */
    show_selectors: {
      type: String,
      default: "campuses",
    },
    /**
     * Mostrará la opcion --TODOS-- en los selectores indicados.
     * @values campuses careers egress_profiles levels periods matters sections professors
     */
    show_all: {
      type: String,
      default: "campuses sections",
    },
    /**
     * Define los selectores requeridos por el usuario.
     * @values campuses careers egress_profiles levels periods matters sections professors
     */
    required_selectors: {
      type: String,
      default: "campuses sections",
    },
    /**
     * Limpia los filtros actuales seleccionados por el usuario.
     */
    clear_filters: {
      type: Boolean,
    },

    /**
     * @param {(Number|string)} ['all'] Define la cantidad máxima permitida para seleccionar.
     */
    max_campuses: { default: "all" },
    max_careers: { default: "all" },
    max_egress_profiles: { default: "all" },
    max_sections: { default: "all" },
    max_matters: { default: "all" },
    max_modalities: { default: "all" },
    max_periods: { default: "all" },
    max_levels: { default: "all" },
    max_study_units: { default: "all" },
    max_cohorts: { default: "all" },
    max_cohort_index: { default: "all" },
    max_cycles: { default: "all" },
    max_student_status: { default: "all" },
    max_is_active_section: { default: "all" },
    max_professors: { default: "all" },
    load_cohorts: { default: false },
    /**
     * Si es true, los filtros de cohorte usan los años/índices retro-calculados
     * (calculated_cohort) en vez de los declarados. Por reporte, opt-in.
     */
    use_calculated_cohorts: {
      type: Boolean,
      default: false,
    },
    /**
     * Desabilita el componente.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Lista de filtros a limpiar selectivamente al cambiar de tipo de reporte.
     */
    filters_to_clear: {
      type: Array,
      default: () => [],
    },
    /**
     * Tipo de reporte seleccionado para determinar el comportamiento del filtro de períodos.
     */
    selected_report_type: {
      type: [Number, String],
      default: null,
    },
    /**
     * Endpoint API para cargar usuarios
     */
    professors_api_endpoint: {
      type: String,
      default: "/authentication/user/",
    },
    /**
     * IDs iniciales para restaurar filtros desde URL.
     * Objeto con claves como 'campuses', 'egress_profiles', etc. y valores como arrays de IDs numéricos.
     */
    initial_filter_ids: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selected_campuses: [],
      selected_careers: [],
      selected_egress_profiles: [],
      selected_modalities: [],
      selected_levels: [],
      selected_periods: [],
      selected_matters: [],
      selected_sections: [],
      selected_study_units: [],
      selected_cohorts: [],
      selected_cohort_indices: [],
      selected_cycles: [],
      selected_student_status: [],
      selected_is_active_section: [],
      selected_professors: [],
      show_campuses_: false,
      show_careers_: false,
      show_egress_profiles_: false,
      show_modalities_: false,
      show_levels_: false,
      show_periods_: false,
      show_matters_: false,
      show_sections_: false,
      show_study_units_: false,
      show_cohorts_: false,
      show_cohort_index_: false,
      show_cycles_: false,
      show_student_status_: false,
      show_is_active_section_: false,
      show_professors_: false,
      cohorts: [
        { value: 2021, name: "2021" },
        { value: 2022, name: "2022" },
      ],
      student_status: [
        { id: 1, name: this.$t("toolbar.reports.inRegime") },
        { id: 2, name: this.$t("toolbar.reports.notInRegime") },
      ],
      /**
       * Temporal para guardar los ids de asignaturas cuyas secciones y unidades de estudio han sido descargadas.
       * Para evitar muchas peticiones repetidas.
       */
      fetched_matters_sections: [],
      fetched_matters_study_unit: [],
      /**
       * IDs de perfiles de egreso cuyas egress-profile-matter ya fueron
       * pedidas al backend (filtradas por egress_profile), para no repetir
       * la petición ni volver a traer el listado completo de la institución.
       */
      fetched_egress_profile_matters: [],
      /**
       * IDs de perfiles de egreso cuyas asignaturas base (mesh.matter) ya
       * fueron pedidas al backend filtradas por egress_profile.
       */
      fetched_egress_profile_base_matters: [],
      fetched_cohorts: [],
      fetched_cohort_indices: [],
      pending_init: { ...(this.initial_filter_ids || {}) },
    };
  },
  computed: {
    ...mapGetters({
      campuses: names.CAMPUSES,
      careers: names.CAREERS,
      egressProfiles: names.EGRESS_PROFILES,
      regimes: names.REGIMES,
      formationAreas: names.FORMATION_AREAS,
      matters: names.MATTERS,
      sections: names.SECTIONS,
      modalities: names.MODALITIES,
      studyUnits: names.STUDY_UNITS,
      egressProfilesMatters: names.EGRESS_PROFILES_MATTERS,
      egress_profile_cycles: names.PROFILE_CYCLES,
      periods: names.PERIODS,
      faculties: names.FACULTIES,
      cycles: names.CYCLES,
    }),
    filteredCampuses() {
      return this.campuses;
    },
    is_active_section() {
      return [
        {
          id: 1,
          name: this.$t("toolbar.reports.currentPeriods", {
            periods: this.$getVisibleNames("mesh.period", true, "Períodos"),
          }),
        },
        {
          id: 2,
          name: this.$t("toolbar.reports.pastPeriods", {
            periods: this.$getVisibleNames("mesh.period", true, "Períodos"),
          }),
        },
      ];
    },

    //  Determina qué campo usar para mostrar los períodos
    //  según el tipo de reporte

    periodLabelField() {
      const shouldShowCount = [1, 4].includes(
        Number(this.selected_report_type)
      );
      return shouldShowCount ? "name_with_count" : "name";
    },
    visibleSelectors() {
      return [
        this.show_campuses_,
        this.show_careers_,
        this.show_egress_profiles_,
        this.show_levels_,
        this.show_modalities_,
        this.show_matters_,
        this.show_periods_,
        this.show_sections_,
        this.show_study_units_,
        this.show_cohorts_,
        this.show_cycles_,
        this.show_student_status_,
        this.show_is_active_section_,
        this.show_professors_,
      ].filter(Boolean).length; // Filtra los selectores visibles
    },
    /**
     * Retorna todas las carreras con el atributo adicional 'faculty_name'.
     */
    filteredCareers() {
      let list = [];
      this.careers.forEach((career) => {
        let faculty = this.faculties.find((x) => x.id == career.faculty);
        if (faculty) {
          career["faculty_name"] = faculty.name;
        }
        list.push(career);
      });
      return list.sort((a, b) => a.name.localeCompare(b.name));
    },
    /**
     * Retorna los perfiles de egreso filtrados por carreras y sedes.
     */
    filteredEgressProfiles() {
      let list = [];
      const selected_campus_id = this.selected_campuses
        ? this.selected_campuses.map((campus) => campus.id)
        : [];
      this.careers.forEach((career) => {
        career.egress_profiles.forEach((egress_profile_id) => {
          let egress_profile = this.egressProfiles.find(
            (x) => x.id == egress_profile_id
          );

          // Si hay una sede seleccionada, se verifican los perfiles que pertenezcan a la sede
          if (selected_campus_id.length > 0) {
            const has_selected_campus =
              egress_profile &&
              egress_profile.campuses &&
              egress_profile.campuses.some((campus) =>
                selected_campus_id.includes(campus)
              );

            if (!has_selected_campus) return;
          }
          let ep_career = null;
          if (egress_profile) {
            ep_career = this.careers.find((x) => x.id == egress_profile.career);
          }
          if (ep_career != null && egress_profile != null) {
            egress_profile["career_name"] = ep_career.name;
            if (egress_profile.code && egress_profile.init_date) {
              if (this.max_egress_profiles == "all") {
                egress_profile["ep_custom_label"] =
                  egress_profile.professional_title;
              }
              if (this.max_egress_profiles != "all") {
                egress_profile["ep_custom_label"] =
                  egress_profile.code +
                  " - " +
                  this.$moment(egress_profile.init_date).format("YYYY") +
                  " - " +
                  egress_profile.professional_title;
              }
            } else {
              egress_profile["ep_custom_label"] =
                egress_profile.professional_title;
            }
            list.push(egress_profile);
          }
        });
      });
      return list.sort((a, b) =>
        a.ep_custom_label.localeCompare(b.ep_custom_label)
      );
    },
    /**
     * Retorna los niveles de acuerdo a los perfiles seleccionados.
     * Por cada nivel crea un objeto con 'id' y 'name' como atributos.
     */
    filteredLevels() {
      let max_level = 0;
      this.selected_egress_profiles.forEach((ep) => {
        if (ep.semester_amount > max_level) {
          max_level = ep.semester_amount;
        }
      });
      return [...Array(max_level).keys()].map(function (i) {
        return { id: i + 1, name: i + 1 };
      });
    },
    filteredModalities() {
      return this.modalities;
    },
    // filteredPeriods() {
    //   let period_list = this.periods;
    //   return period_list.sort((a, b) => (a.start_date < b.start_date ? 1 : -1));
    // },
    filteredPeriods() {
      let period_list = this.periods;

      // Solo agregar conteo para tipos de reporte 1 y 4, filtrar períodos vacíos también para tipo 5
      const shouldShowCount = [1, 4, 5].includes(
        Number(this.selected_report_type)
      );

      if (shouldShowCount) {
        const selectedMatterIds = this.selected_matters.map(
          (matter) => matter.id
        );
        // Agregar conteo de secciones a todos los períodos
        const periodsWithCount = period_list.map((period) => {
          // Contar secciones para este período, filtrando por asignatura si hay seleccionadas
          const sectionCount = this.sections.filter(
            (section) =>
              section.period === period.id &&
              (selectedMatterIds.length === 0 ||
                selectedMatterIds.includes(section.egress_profile_matter))
          ).length;

          return {
            ...period,
            section_count: sectionCount,
            name_with_count: `${period.name} (${sectionCount})`,
          };
        });

        return periodsWithCount
          .filter((period) => period.section_count > 0)
          .sort((a, b) => (a.start_date < b.start_date ? 1 : -1));
      } else {
        // Para otros tipos de reporte, devolver períodos sin modificar
        return period_list.sort((a, b) =>
          a.start_date < b.start_date ? 1 : -1
        );
      }
    },
    filteredMatters() {
      let formatted_matters = [];
      let ep_matter_list = this.egressProfilesMatters.filter((ep_matter) =>
        this.selected_egress_profiles
          .map((ep) => ep.id)
          .includes(Number(ep_matter.egress_profile))
      );
      if (this.show_levels_ && this.selected_levels.length > 0) {
        ep_matter_list = ep_matter_list.filter((matter) =>
          this.selected_levels
            .map((level) => level.id)
            .some((level_id) => matter.plan_level == level_id)
        );
      }
      if (this.show_modalities_) {
        ep_matter_list = ep_matter_list.filter((matter) =>
          this.selected_modalities
            .map((modality) => modality.id)
            .some(
              (modality_id) =>
                !matter.modality || matter.modality == modality_id
            )
        );
      }
      ep_matter_list.forEach((ep_matter_) => {
        let new_matter = this.matters.find(
          (matter_) => ep_matter_.matter == matter_.id
        );
        if (new_matter) {
          if (this.max_matters == "all") {
            ep_matter_.matter_name = new_matter.name;
          }
          if (this.max_matters != "all") {
            ep_matter_.matter_name =
              ep_matter_.effective_code + " - " + new_matter.name;
          }
          formatted_matters.push(ep_matter_);
        }
      });
      return formatted_matters;
    },
    filteredCycles() {
      if (this.selected_egress_profiles.length == 0) return [];
      const cycles_ids = [
        ...new Set(
          this.egress_profile_cycles
            .filter((x) =>
              this.selected_egress_profiles
                .map((ep) => ep.id)
                .includes(Number(x.egress_profile))
            )
            .map((x) => x.cycle)
        ),
      ];
      return [...this.cycles.filter((x) => cycles_ids.includes(x.id))];
    },
    filteredSections() {
      let list = [];
      this.selected_matters.forEach((ep_matter) => {
        ep_matter.sections.forEach((section_id) => {
          let section = this.sections.find((x) => x.id == section_id);
          if (this.selected_periods.length || this.selected_matters.length) {
            const selected_matter_id = this.selected_matters.map(
              (matter) => matter.id
            );
            const selected_period_id = this.selected_periods.map(
              (period) => period.id
            );
            const selected_campus_id = this.selected_campuses.map(
              (campus) => campus.id
            );
            list = this.sections.filter((section) => {
              const matchesPeriod = selected_period_id.includes(section.period);
              const matchesMatter = selected_matter_id.includes(
                section.egress_profile_matter
              );
              const matchesCampus =
                selected_campus_id.length == 0 ||
                selected_campus_id.includes(section.campus);

              return matchesPeriod && matchesMatter && matchesCampus;
            });
          } else {
            if (section) {
              list.push(section);
            }
          }
        });
      });
      return list;
    },
    filteredStudyUnits() {
      let list = [];
      const mattersToUse =
        this.selected_matters.length > 0
          ? this.selected_matters
          : this.filteredMatters;
      mattersToUse.forEach((ep_matter) => {
        let study_units = this.studyUnits.filter(
          (x) => x.matter == ep_matter.matter
        );
        list.push(...study_units);
      });
      return list;
    },
  },
  methods: {
    /**
     * Carga las cohortes (y sus índices) del primer perfil de egreso seleccionado.
     * Con use_calculated_cohorts usa los años/índices retro-calculados; si no, los
     * declarados (comportamiento histórico). Consolida los tres fetch antes duplicados.
     */
    fetchCohorts() {
      if (!this.selected_egress_profiles.length) return;
      const egress_profile_id = this.selected_egress_profiles[0].id;
      if (this.use_calculated_cohorts) {
        this.$restful
          .Get(
            `/teaching/get_egress_profile_calculated_cohorts/?egress_profile=${egress_profile_id}`
          )
          .then((response) => {
            this.fetched_cohorts = (response.cohorts || [])
              .filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.cohort === item.cohort)
              )
              .sort((a, b) => b.cohort - a.cohort);
            this.fetched_cohort_indices = (response.cohort_indices || [])
              .filter(
                (item, index, self) =>
                  index ===
                  self.findIndex((t) => t.cohort_index === item.cohort_index)
              )
              .sort((a, b) => a.cohort_index - b.cohort_index);
          });
      } else {
        this.$restful
          .Get(
            `/teaching/get_egress_profile_cohorts/?egress_profile=${egress_profile_id}`
          )
          .then((response) => {
            this.fetched_cohorts = response
              .filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.cohort === item.cohort)
              )
              .sort((a, b) => b.cohort - a.cohort);
          });
      }
    },
    /**
     * Pide las egress-profile-matter de un perfil de egreso puntual (filtradas
     * por egress_profile en el backend) en vez de traer las de toda la
     * institución. Evita repetir la petición si ya se pidieron antes.
     */
    fetchEgressProfileMatters(egress_profile_id) {
      if (this.fetched_egress_profile_matters.includes(egress_profile_id))
        return;
      this.fetched_egress_profile_matters.push(egress_profile_id);
      this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
        egress_profile_id,
      });
    },
    /**
     * Pide las asignaturas base (mesh.matter) de un perfil de egreso puntual
     * (filtradas por egress_profile en el backend). Evita repetir la
     * petición si ya se pidieron antes.
     */
    fetchMatters(egress_profile_id) {
      if (this.fetched_egress_profile_base_matters.includes(egress_profile_id))
        return;
      this.fetched_egress_profile_base_matters.push(egress_profile_id);
      this.$store.dispatch(names.FETCH_MATTERS, {
        egress_profile_id,
      });
    },
    // stateKey permite que la clave del filtro en la URL (p. ej. "cohort_index")
    // difiera del nombre de la propiedad del estado (selected_cohort_indices).
    applyInitialFilter(filterName, options, idField = "id", stateKey = filterName) {
      const ids = this.pending_init[filterName];
      if (ids == null) return false;
      if (!options || options.length === 0) return false;
      // Centinela "all": selecciona todas las opciones disponibles.
      const selected =
        ids === "all"
          ? [...options]
          : ids.length === 0
          ? []
          : options.filter((opt) => ids.includes(opt[idField]));
      if (selected.length > 0) {
        this[`selected_${stateKey}`] = selected;
        delete this.pending_init[filterName];
        return true;
      }
      return false;
    },
    setupInitialFilterWatchers() {
      const sources = {
        campuses: { options: () => this.campuses, idField: "id" },
        egress_profiles: { options: () => this.filteredEgressProfiles, idField: "id" },
        levels: { options: () => this.filteredLevels, idField: "id" },
        periods: { options: () => this.filteredPeriods, idField: "id" },
        matters: { options: () => this.filteredMatters, idField: "id" },
        sections: { options: () => this.filteredSections, idField: "id" },
        study_units: { options: () => this.filteredStudyUnits, idField: "id" },
        cohorts: { options: () => this.fetched_cohorts, idField: "cohort" },
        cohort_index: {
          options: () => this.fetched_cohort_indices,
          idField: "cohort_index",
          stateKey: "cohort_indices",
        },
        cycles: { options: () => this.filteredCycles, idField: "id" },
        student_status: { options: () => this.student_status, idField: "id" },
        is_active_section: { options: () => this.is_active_section, idField: "id" },
      };
      let retries = 0;
      const maxRetries = 20;
      const tryApply = () => {
        const pendingKeys = Object.keys(this.pending_init);
        if (pendingKeys.length === 0 || retries >= maxRetries) return;
        let anyApplied = false;
        pendingKeys.forEach((filter) => {
          const config = sources[filter];
          if (
            config &&
            this.applyInitialFilter(
              filter,
              config.options(),
              config.idField,
              config.stateKey
            )
          ) {
            anyApplied = true;
          }
        });
        if (Object.keys(this.pending_init).length > 0) {
          if (anyApplied) {
            this.$nextTick(tryApply);
          } else {
            retries++;
            setTimeout(tryApply, 500);
          }
        }
      };
      tryApply();
    },
  },
  watch: {
    /**
     * Modifica la visivilidad de los selectores en variables internas.
     * Funciona como optimización.
     */
    show_selectors: {
      handler() {
        this.show_campuses_ = false;
        this.show_careers_ = false;
        this.show_egress_profiles_ = false;
        this.show_modalities_ = false;
        this.show_levels_ = false;
        this.show_periods_ = false;
        this.show_matters_ = false; // Asignaturas de Perfil de Egreso
        this.show_sections_ = false;
        this.show_study_units_ = false;
        this.show_cohorts_ = false;
        this.show_cohort_index_ = false;
        this.show_cycles_ = false;
        this.show_student_status_ = false;
        this.show_is_active_section_ = false;
        this.show_professors_ = false;
        if (this.show_selectors.includes("campuses"))
          this.show_campuses_ = true;
        if (this.show_selectors.includes("careers")) this.show_careers_ = true;
        if (this.show_selectors.includes("egress_profiles"))
          this.show_egress_profiles_ = true;
        if (this.show_selectors.includes("modalities"))
          this.show_modalities_ = true;
        if (this.show_selectors.includes("levels")) this.show_levels_ = true;
        if (this.show_selectors.includes("periods")) this.show_periods_ = true;
        if (this.show_selectors.includes("matters")) this.show_matters_ = true;
        if (this.show_selectors.includes("sections"))
          this.show_sections_ = true;
        if (this.show_selectors.includes("study_units"))
          this.show_study_units_ = true;
        if (this.show_selectors.includes("cohorts")) this.show_cohorts_ = true;
        if (this.show_selectors.includes("cohort_index"))
          this.show_cohort_index_ = true;
        if (this.show_selectors.includes("cycles")) this.show_cycles_ = true;
        if (this.show_selectors.includes("student_status"))
          this.show_student_status_ = true;
        if (this.show_selectors.includes("is_active_section"))
          this.show_is_active_section_ = true;
        if (this.show_selectors.includes("professors"))
          this.show_professors_ = true;

        // Disparar fetches para selectores recién visibles que dependen de datos ya seleccionados
        if (
          (this.show_cohorts_ || this.show_cohort_index_) &&
          this.selected_egress_profiles.length
        ) {
          this.fetchCohorts();
        }
        if (this.show_cycles_ && this.selected_egress_profiles.length) {
          this.$store.dispatch(names.FETCH_PROFILE_CYCLES, {
            egress_profile_ids: this.selected_egress_profiles.map(
              (element) => element.id
            ),
          });
        }
        if (this.show_matters_ && this.selected_egress_profiles.length) {
          this.selected_egress_profiles.forEach((element) => {
            this.fetchEgressProfileMatters(element.id);
            this.fetchMatters(element.id);
          });
        }
        if (this.show_sections_ && this.selected_matters.length) {
          this.selected_matters.forEach((ep_matter) => {
            if (
              !this.fetched_matters_sections.find((x) => x == ep_matter.id)
            ) {
              this.$store.dispatch(names.FETCH_SECTIONS, {
                egress_profile_matter_id: ep_matter.id,
              });
              this.fetched_matters_sections.push(ep_matter.id);
            }
          });
        }
        if (this.show_study_units_ && this.selected_matters.length) {
          this.selected_matters.forEach((ep_matter) => {
            if (
              !this.fetched_matters_study_unit.find((x) => x == ep_matter.id)
            ) {
              this.$store.dispatch(names.FETCH_STUDY_UNITS, ep_matter.matter);
              this.fetched_matters_study_unit.push(ep_matter.id);
            }
          });
        }
      },
      immediate: true,
    },
    /**
     * Observa cuando cambian las asignaturas selleccionadas.
     * Pide las secciones y unidades de las asignaturas seleccionadas si no han sido cargadas con anteriorida.
     */
    selected_matters() {
      this.$emit("matters", this.selected_matters);
      this.selected_matters.forEach((ep_matter) => {
        // Fetchear secciones si el selector está visible O si el tipo de reporte
        // necesita filtrar períodos por secciones (ej. tipo 5) aunque no muestre el selector
        const needsSectionsForPeriodFilter = [5].includes(
          Number(this.selected_report_type)
        );
        if (
          (this.show_sections_ || needsSectionsForPeriodFilter) &&
          !this.fetched_matters_sections.find((x) => x == ep_matter.id)
        ) {
          this.$store.dispatch(names.FETCH_SECTIONS, {
            egress_profile_matter_id: ep_matter.id,
          });
          this.fetched_matters_sections.push(ep_matter.id);
        }
        if (
          this.show_study_units_ &&
          !this.fetched_matters_study_unit.find((x) => x == ep_matter.id)
        ) {
          this.$store.dispatch(names.FETCH_STUDY_UNITS, ep_matter.matter);
          this.fetched_matters_study_unit.push(ep_matter.id);
        }
      });
    },
    selected_campuses() {
      this.$emit("campuses", this.selected_campuses);
    },
    selected_careers() {
      this.$emit("careers", this.selected_careers);
    },
    selected_egress_profiles() {
      this.$emit("egress_profiles", this.selected_egress_profiles);
      this.selected_cycles = [];
      this.cohort = [];
      if (this.show_cycles_)
        this.$store.dispatch(names.FETCH_PROFILE_CYCLES, {
          egress_profile_ids: this.selected_egress_profiles.map(
            (element) => element.id
          ),
        });
      if (this.show_matters_)
        this.selected_egress_profiles.forEach((element) => {
          this.fetchEgressProfileMatters(element.id);
          this.fetchMatters(element.id);
        });
      if (
        (this.show_cohorts_ || this.show_cohort_index_) &&
        this.selected_egress_profiles.length
      ) {
        this.fetchCohorts();
      }
    },
    selected_modalities() {
      this.$emit("modalities", this.selected_modalities);
    },
    selected_levels() {
      this.$emit("levels", this.selected_levels);
      this.selected_egress_profiles.forEach((ep) => {
        if (this.show_matters_) {
          this.fetchMatters(ep.id);
        }
      });
    },
    selected_periods() {
      this.$emit("periods", this.selected_periods);
    },
    selected_sections() {
      this.$emit("sections", this.selected_sections);
    },
    selected_study_units() {
      this.$emit("study_units", this.selected_study_units);
    },
    selected_cohorts() {
      this.$emit("cohorts", this.selected_cohorts);
    },
    selected_cohort_indices() {
      this.$emit("cohort_indices", this.selected_cohort_indices);
    },
    selected_cycles() {
      this.$emit("cycles", this.selected_cycles);
    },
    selected_student_status() {
      this.$emit("student_status", this.selected_student_status);
    },
    selected_is_active_section() {
      this.$emit("is_active_section", this.selected_is_active_section);
    },
    selected_professors() {
      this.$emit("professors", this.selected_professors);
    },
    filters_to_clear(filterNames) {
      if (filterNames && filterNames.length > 0) {
        filterNames.forEach((filterName) => {
          const key = `selected_${filterName}`;
          if (this[key] !== undefined) {
            this[key] = [];
          }
        });
      }
    },
    clear_filters() {
      this.selected_campuses = [];
      this.selected_egress_profiles = [];
      this.selected_levels = [];
      this.selected_periods = [];
      this.selected_matters = [];
      this.selected_sections = [];
      this.selected_study_units = [];
      this.selected_cohorts = [];
      this.selected_cohort_indices = [];
      this.selected_cycles = [];
      this.selected_student_status = [];
      this.selected_is_active_section = [];
      this.selected_professors = [];
    },
    load_cohorts() {
      if (this.load_cohorts && this.selected_egress_profiles.length) {
        this.fetchCohorts();
      }
    },
  },
  created() {
    if (Object.keys(this.pending_init).length > 0) {
      this.setupInitialFilterWatchers();
    }
  },
};
</script>

<style scoped>
.selectors-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.selectors {
  box-sizing: border-box;
}

/* Distribución automática basada en el número de selectores visibles */
/* 2 por fila (4 selectores) */
.selectors-container.selectors-4 .selectors {
  flex: 1 1 calc(50% - 20px);
  max-width: calc(50% - 20px);
}

/* 3 por fila (6 selectores) */
.selectors-container.selectors-6 .selectors {
  flex: 1 1 calc(33.33% - 20px);
  max-width: calc(33.33% - 20px);
}

/* 4 por fila (8 selectores) */
.selectors-container.selectors-8 .selectors {
  flex: 1 1 calc(25% - 20px);
  max-width: calc(25% - 20px);
}

/* Caso genérico: 2 por fila si no hay clase específica */
.selectors-container .selectors {
  flex: 1 1 calc(50% - 20px);
  max-width: calc(50% - 20px);
}
@media (max-width: 768px) {
  .selectors {
    flex: 1 1 calc(100%) !important;
    max-width: calc(100%) !important;
  }
}
</style>